import {EventEmitter, Injectable} from '@angular/core';
import {Message, MessageService} from 'primeng/api';
import {PleaseWaitComponent} from '../../components/please-wait/please-wait.component';
import {UpdaterService} from '../updater/updater.service';
import {ElectronService} from 'ngx-electron';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  actionMessagesCount: number = 0;
  messageEvent: EventEmitter<Message> = new EventEmitter<Message>();
  pleaseWaitView: PleaseWaitComponent;

  constructor(public messageService: MessageService,
              public updaterService: UpdaterService,
              private electronService: ElectronService) {
    this.messageService = messageService;
    this.updaterService = updaterService;

    this.initImpersonation();
    this.initWindowCommunication();
  }

  private initWindowCommunication() {
    if (!this.electronService.isElectronApp) {
      window.addEventListener('message', (event) => {
        if (event.data.key === 'notification') {
          this.messageService.add(event.data.notification);
          this.messageEvent.emit(event.data.notification);
        }
      });
    } else {
      this.electronService.ipcRenderer.on('window-communication', (event, args) => {
        if (args.key === 'notification') {
          this.messageService.add(args.message);
          this.messageEvent.emit(args.message);
        }
      });
    }
  }

  private initImpersonation() {
    // ts-ignore
    window['impersonate'] = (userId: string) => {
      this.impersonate(userId);
    };
  }

  showSuccessMessage(message: string, options: { sticky?: boolean, force?: boolean, windowId?: string } = {}) {
    const msg = {key: 'notification', severity: 'success', summary: 'Success', detail: message, life: 5000, sticky: options.sticky};
    this.showMessage(msg, options);
  }

  showErrorMessage(message: string, options: { sticky?: boolean, force?: boolean, windowId?: string } = {}) {
    const msg = {key: 'notification', severity: 'error', summary: 'Error', detail: message, life: 10000, sticky: options.sticky, data: {error: message}};
    this.showMessage(msg, options);
  }

  showWarnMessage(message: string, options: { sticky?: boolean, force?: boolean, windowId?: string } = {}) {
    const msg = {key: 'notification', severity: 'warn', summary: 'Warning', detail: message, life: 10000, sticky: options.sticky};
    this.showMessage(msg, options);
  }

  showInfoMessage(message: string, options: { windowId?: string, force?: boolean, life?: number } = {}) {
    const msg = {key: 'notification', severity: 'info', summary: 'Info', detail: message, life: options.life};
    this.showMessage(msg, options);
  }

  async showMessage(message: Message, options: { windowId?: string, force?: boolean, life?: number } = {}) {
    if (!options.windowId) {
      this.messageService.add(message);
    } else {
      if (this.electronService.isElectronApp) {
        this.electronService.ipcRenderer.send('window-communication', {
          data: {
            key: 'notification',
            message: message,
          }, windowId: options.windowId
        });
      } else {
        if (window.opener) {
          window.opener.postMessage({key: 'notification', notification: message, windowId: options.windowId}, '*');
        } else {
          this.messageService.add(message);
        }
      }
    }
  }

  private async impersonate(userId: string) {
    await localStorage.setItem('jwtToken', userId);
    await localStorage.removeItem('tenantDto');
    await localStorage.removeItem('tabs');
    window.location.reload();
  }

  async sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
